import React, { useState, useCallback, useEffect } from "react";
import { Grid } from "@mui/material";
import Sidebar from "./filter";
import ClientList from "./list";
import clientsApi from "../../services/clients";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/snackbar/actions";
import { showLoader, hideLoader } from "../../redux/loader/actions";

function Manage_Products() {
  const dispatch = useDispatch();
  const [searchparams, setSearchparams] = useState({});
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [userData, setUserData] = useState({});
  const [clientId, setClientId] = useState(true);

  const fetchUsers = useCallback(async () => {
    dispatch(showLoader());
    try {
      const response = await clientsApi.getAllUsers(
        paginationModel.page + 1,
        paginationModel.pageSize,
        searchparams
      );

      const responseData = response?.data?.data;
      if (responseData) {
        setUserData(responseData);
        setRowCount(responseData.pagination.totalItems);
      } else {
        console.warn("Unexpected response format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching pricing:", error);
    } finally {
      dispatch(hideLoader());
    }
  }, [paginationModel.page, paginationModel.pageSize, searchparams, dispatch]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <Grid container spacing={3} mt={2}>
      <Grid item xs={12} sm={12} md={3}>
        <Sidebar
          setSearchparams={setSearchparams}
          searchparams={searchparams}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          clientId={clientId}
          setClientId={setClientId}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={9}>
        <ClientList
          userData={userData}
          rowCount={rowCount}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          clientId={clientId}
          setClientId={setClientId}
        />
      </Grid>
    </Grid>
  );
}
export default Manage_Products;
